module.exports = {
  banners: 'banners',
  mobile_banners: 'mobile_banners',
  thumbnails: 'thumbnails',
  icons: 'icons',
  logos: 'logos',
  videos: 'videos',
  images: 'images'
}
